import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
    FaBars,
    FaTimes,
    FaSignInAlt,
    FaMoon,
    FaSun,
    FaChevronDown,
    FaTachometerAlt,
} from "react-icons/fa";
import { LiaSignInAltSolid } from "react-icons/lia";
import Navstyles from "../Comman.module.css";
import Logo from "../../../Assets/KohereHedaer.png";
import Logoblue from "../../../Assets/login/blue-logo.svg";
import { getAllCategoryWithServices } from "../../../Services/APIrequests";
import useStore from "../../../Store";
import { FaCircle } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";

// import { useLocation } from "react-router-dom";
const Nav = () => {
    const { name } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [themeDropdownOpen, setThemeDropdownOpen] = useState(false);
    const [selectedTheme, setSelectedTheme] = useState("");
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1440);
    const [isOpen, setIsOpen] = useState(true);
    const [subCategories, setSubCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { Theme, setTheme } = useStore();
    const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
    const [categoriesWithServices, setCategoriesWithServices] = useState([]);
    const [openCategory, setOpenCategory] = useState(null); // to track which category is open

    const dropdownRef = useRef(null);

    const isServiceActive = location.pathname.startsWith("/services");
    console.log(location.pathname);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setThemeDropdownOpen(false);
            }
        };

        // Add the event listener to detect clicks outside
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Toggle Theme
    const toggleTheme = (theme) => {
        const newTheme = theme != "blue" ? "dark" : "default";
        setTheme(newTheme);
        setSelectedTheme(theme);
        document.documentElement.setAttribute("data-theme", newTheme);
    };

    const handleNavigation = () => {
        navigate("/kohere/Dashboard");
    };

    // Fetch services and categories from API
    useEffect(() => {
        const fetchServicesData = async () => {
            setLoading(true);
            try {
                const response = await getAllCategoryWithServices();
                if (Array.isArray(response.data?.categoriesWithServices)) {
                    setCategoriesWithServices(
                        response.data?.categoriesWithServices
                    );
                } else {
                    console.error(
                        "API response is not an array:",
                        response.data?.categoriesWithServices
                    );
                }
            } catch (err) {
                console.error("Error fetching services:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchServicesData();
    }, []);

    useEffect(() => {
        let theme = sessionStorage.getItem("theme");
        if (theme) {
            setSelectedTheme(theme == "dark" ? "green" : "blue");
        }
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 1024);
            setIsOpen(window.innerWidth > 950);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const signup = () =>
        navigate("/signup", { state: { from: location.pathname } });
    const login = () => {
        console.log(location.pathname);
        sessionStorage.setItem("redirectUrl", location.pathname);
        navigate("/login", { state: { from: location.pathname } });
    };

    const logout = () => {
        sessionStorage.removeItem("token");
        navigate("/");
    };

    const isHomePage = location.pathname === "/";
    const isLoggedIn = Boolean(sessionStorage.getItem("token"));

    return (
        <nav>
            <div className={Navstyles["main_navcontainer"]}>
                {/* Logo */}
                <div className={Navstyles["image_container"]}>
                    <Link to="/">
                        <img
                            src={Theme === "dark" ? Logo : Logoblue}
                            alt="logo"
                            className={Navstyles.hedimage}
                        />
                    </Link>
                </div>

                {/* Navigation Links */}
                {!loading && (
                    <div className={Navstyles["navcontainer"]}>
                        <ul
                            className={`${Navstyles.navitems} ${
                                menuOpen ? Navstyles.open : ""
                            }`}>
                            <li>
                                <NavLink
                                    exact="true"
                                    to="/BusinessesforSale"
                                    style={({ isActive }) =>
                                        isActive
                                            ? {
                                                  color: "var(--PrimaryColor)",
                                                  fontWeight: "bold",
                                              }
                                            : { color: "inherit" }
                                    }>
                                    Businesses for Sale
                                </NavLink>
                            </li>

                            {categoriesWithServices.map((item) => (
                                <li
                                    className={Navstyles.navservicesitem}
                                    onMouseEnter={() =>
                                        setIsServicesDropdownOpen(
                                            item.categoryName
                                        )
                                    }
                                    onMouseLeave={() =>
                                        setIsServicesDropdownOpen(null)
                                    }
                                    key={item.categoryName}>
                                    <NavLink
                                        exact="true"
                                        to={`/services/${item.categoryName.replace(
                                            /\s+/g,
                                            "_"
                                        )}`}
                                        style={({ isActive }) =>
                                            isActive
                                                ? {
                                                      color: "var(--PrimaryColor)",
                                                      fontWeight: "bold",
                                                  } // Bold for active category
                                                : { color: "inherit" }
                                        }>
                                        {item.categoryName}
                                        {/* Show the dropdown icon only if there are services */}
                                        {item.services &&
                                            item.services.length > 0 && (
                                                <span
                                                    className={
                                                        Navstyles.mobileOnly
                                                    }
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setIsServicesDropdownOpen(
                                                            (prev) =>
                                                                prev ===
                                                                item.categoryName
                                                                    ? null
                                                                    : item.categoryName
                                                        );
                                                    }}>
                                                    <FaChevronDown
                                                        className={
                                                            Navstyles.downicon
                                                        }
                                                    />
                                                </span>
                                            )}
                                    </NavLink>

                                    {/* Dropdown Services (Visible on Hover for Desktop) */}
                                    {isServicesDropdownOpen ===
                                        item.categoryName &&
                                        item.services &&
                                        item.services.length > 0 && (
                                            <div
                                                className={
                                                    Navstyles.navservicesitems_category
                                                }>
                                                {item.services.map(
                                                    (service) => (
                                                        <NavLink
                                                            key={
                                                                service.serviceId
                                                            }
                                                            to={`/services/${
                                                                service.serviceId
                                                            }/${encodeURIComponent(
                                                                service.title.replace(
                                                                    /\s+/g,
                                                                    "-"
                                                                )
                                                            )}`}
                                                            style={({
                                                                isActive,
                                                            }) =>
                                                                isActive
                                                                    ? {
                                                                          color: "var(--PrimaryColor)",
                                                                          fontWeight:
                                                                              "bold",
                                                                      }
                                                                    : {
                                                                          color: "inherit",
                                                                          fontWeight:
                                                                              "400",
                                                                      }
                                                            }>
                                                            {service?.title}
                                                        </NavLink>
                                                    )
                                                )}
                                            </div>
                                        )}
                                </li>
                            ))}

                            <li>
                                <NavLink
                                    exact="true"
                                    to="/resources"
                                    style={({ isActive }) =>
                                        isActive
                                            ? {
                                                  color: "var(--PrimaryColor)",
                                                  fontWeight: "bold",
                                              }
                                            : { color: "inherit" }
                                    }>
                                    Resources
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    exact="true"
                                    to="/blog"
                                    style={({ isActive }) =>
                                        isActive
                                            ? {
                                                  color: "var(--PrimaryColor)",
                                                  fontWeight: "bold",
                                              }
                                            : { color: "inherit" }
                                    }>
                                    Blog
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                )}

                {/* Buttons */}
                <div className={Navstyles["button-container"]}>
                    <div className={Navstyles["theme-dropdown-container"]}>
                        <button
                            className={Navstyles.nbtn}
                            onClick={() =>
                                setThemeDropdownOpen(!themeDropdownOpen)
                            }>
                            {isDesktop ? (
                                <>
                                    <FaSun
                                        className={Navstyles.nbtnicon}
                                        data-tooltip-id="theme-sun-tooltip"
                                        onClick={() =>
                                            setThemeDropdownOpen(
                                                !themeDropdownOpen
                                            )
                                        }
                                    />
                                    <Tooltip
                                        id="theme-sun-tooltip"
                                        content="Theme"
                                        place="left-start"
                                    />
                                </>
                            ) : (
                                <>
                                    <FaSun
                                        className={Navstyles.nbtnicon}
                                        data-tooltip-id="theme-sun-tooltip"
                                        onClick={() =>
                                            setThemeDropdownOpen(
                                                !themeDropdownOpen
                                            )
                                        }
                                    />
                                    <Tooltip
                                        id="theme-sun-tooltip"
                                        content="Theme"
                                        place="left-start"
                                    />
                                </>
                            )}
                        </button>

                        {themeDropdownOpen && (
                            <div
                                ref={dropdownRef}
                                className={Navstyles["theme-dropdown"]}>
                                <div
                                    onClick={() => toggleTheme("green")}
                                    className={Navstyles["theme-option"]}>
                                    <FaCircle
                                        checked={selectedTheme === "green"}
                                        readOnly
                                        className={Navstyles.themecircle1}
                                    />
                                </div>
                                <div
                                    onClick={() => toggleTheme("blue")}
                                    className={Navstyles["theme-option"]}>
                                    <FaCircle
                                        checked={selectedTheme === "blue"}
                                        readOnly
                                        className={Navstyles.themecircle2}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {isLoggedIn && (
                        <span
                            className={Navstyles.nbtn}
                            onClick={handleNavigation}>
                            {isDesktop ? (
                                <>
                                    Dashboard
                                    <Tooltip
                                        id="dashboard-tooltip"
                                        content="Dashboard"
                                    />
                                </>
                            ) : (
                                <>
                                    <FaTachometerAlt
                                        className={Navstyles.nbtnicon}
                                        data-tooltip-id="dashboard-tooltip"
                                    />
                                    <Tooltip
                                        id="dashboard-tooltip"
                                        content="Dashboard"
                                        place="left-start"
                                    />
                                </>
                            )}
                        </span>
                    )}

                    <span className={Navstyles.nbtn}>
                        {isLoggedIn ? (
                            isDesktop ? (
                                <>
                                    <button
                                        onClick={logout}
                                        className={Navstyles.nbtnlogout}
                                        data-tooltip-id="logout-tooltip">
                                        <FaSignInAlt />
                                    </button>
                                    <Tooltip
                                        id="logout-tooltip"
                                        content="Log Out"
                                        place="left-start"
                                    />
                                </>
                            ) : (
                                <>
                                    <FaSignInAlt
                                        className={Navstyles["nbtnicon"]}
                                        onClick={logout}
                                        data-tooltip-id="logout-tooltip"
                                    />
                                    <Tooltip
                                        id="logout-tooltip"
                                        content="Log Out"
                                        place="left-start"
                                    />
                                </>
                            )
                        ) : true ? (
                            isDesktop ? (
                                <>
                                    <button
                                        type="button"
                                        className={Navstyles.nbtnlogout}
                                        onClick={login}
                                        data-tooltip-id="signin-tooltip">
                                        Sign In
                                    </button>
                                    <Tooltip
                                        id="signin-tooltip"
                                        content="Sign In"
                                        place="left-start"
                                    />
                                </>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        className={Navstyles.nbtnlogout}
                                        onClick={login}
                                        data-tooltip-id="signin-tooltip">
                                        Sign In
                                    </button>
                                    <Tooltip
                                        id="signin-tooltip"
                                        content="Sign In"
                                        place="left-start"
                                    />
                                </>
                            )
                        ) : isDesktop ? (
                            <>
                                <button
                                    type="button"
                                    className={Navstyles.nbtn}
                                    onClick={signup}
                                    data-tooltip-id="signup-tooltip">
                                    Sign Up
                                </button>
                                <Tooltip
                                    id="signup-tooltip"
                                    content="Sign Up"
                                    place="left-start"
                                />
                            </>
                        ) : (
                            <>
                                <LiaSignInAltSolid
                                    className={Navstyles["nbtnicon"]}
                                    onClick={signup}
                                    data-tooltip-id="signup-tooltip"
                                />
                                <Tooltip
                                    id="signup-tooltip"
                                    content="Sign Up"
                                    place="left-start"
                                />
                            </>
                        )}
                    </span>

                    <button
                        className={Navstyles["menu"]}
                        type="button"
                        onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {/* Mobile Menu Toggle */}
            </div>
        </nav>
    );
};

export default Nav;
